import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/utils/styles/cn'
import { Check } from 'lucide-react'
import { useRef } from 'react'

const PRESET_COLORS = ['#649EF4', '#E9A139', '#1FB47E', '#E24831', '#E23FC4']

type IDirectoryColorPickerProps = {
    value: string
    onChange: (color: string) => void
}
export const DirectoryColorPicker = ({ value, onChange }: IDirectoryColorPickerProps) => {
    const colorPickerRef = useRef<HTMLInputElement>(null)

    return (
        <div className="flex gap-2 items-center">
            {PRESET_COLORS.map((color) => (
                <Button
                    variant="unstyled"
                    key={color}
                    type="button"
                    onClick={() => onChange(color)}
                    className={cn(
                        'w-7 h-7 rounded-full transition-all relative p-0',
                        value === color && 'ring-2 ring-offset-2 ring-[#BF6323]'
                    )}
                    style={{ backgroundColor: color }}
                >
                    {value === color && (
                        <div className="absolute inset-0 flex items-center justify-center">
                            <Check className="w-4 h-4 text-white" strokeWidth={2} />
                        </div>
                    )}
                </Button>
            ))}

            <div className="relative">
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            variant="unstyled"
                            type="button"
                            className={cn(
                                'w-7 h-7 rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center hover:border-gray-400 transition-colors p-0'
                            )}
                            style={{
                                borderColor: !PRESET_COLORS.includes(value) ? value : '',
                            }}
                            onClick={() => {
                                colorPickerRef.current?.focus()
                                colorPickerRef.current?.click()
                            }}
                        >
                            <span className="text-gray-400 text-xl leading-none mt-[-3px]">+</span>
                        </Button>
                    </TooltipTrigger>

                    <TooltipContent>Pick a custom color</TooltipContent>
                </Tooltip>

                <input
                    ref={colorPickerRef}
                    type="color"
                    value={value}
                    className="h-px w-px absolute bg-transparent border-none -left-1/2 translate-x-1/2 -bottom-2 border-transparent outline-transparent"
                    onChange={(e) => {
                        onChange(e.target.value)
                    }}
                />
            </div>
        </div>
    )
}
